import { buildUrl, handleResponse } from "./auth";

export const getPublicPricingSettings = () =>
  fetch(buildUrl("/api/settings/pricing")).then(handleResponse);

export const getPublicStatusSettings = () =>
  fetch(buildUrl("/api/settings/status")).then(handleResponse);

export const getPublicContentSettings = () =>
  fetch(buildUrl("/api/settings/content")).then(handleResponse);

const publicSettingsApi = {
  getPublicPricingSettings,
  getPublicStatusSettings,
  getPublicContentSettings,
};

export default publicSettingsApi;
